import {
  getRequestGeneric,
  postRequestGeneric,
  putRequestGeneric,
} from "@/services/backendApiGeneric";
import { API_BASE_URL } from "@/config";

export interface OnboardingStatus {
  completed: boolean;
  currentStep: string;
  startedAt?: string | null;
  completedAt?: string | null;
}

export function fetchOnboardingStatus(): Promise<OnboardingStatus> {
  return getRequestGeneric("/protected/onboarding/status");
}

export function setOnboardingStep(step: string) {
  return putRequestGeneric("/protected/onboarding/step", { step }, true);
}

export function completeOnboarding() {
  return postRequestGeneric("/protected/onboarding/complete", null, true);
}

// ─── Contact CSV-Import ────────────────────────────────────────────────

export interface ContactImportDuplicate {
  /** 1-basierte Datenzeile (ohne Header). */
  row: number;
  name?: string;
  reason: string;
}

export interface ContactImportPreview {
  headers: string[];
  suggestedMapping: Record<string, string>;
  rows: string[][];
  totalRows: number;
  canonicalFields: string[];
  /** Warnung: Zeilen, die bereits vorhandenen Kontakten entsprechen (auf Basis des vorgeschlagenen Mappings). */
  duplicates?: ContactImportDuplicate[];
}

export async function previewContactImport(file: File): Promise<ContactImportPreview> {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API_BASE_URL}/protected/contacts/import/preview`, {
    method: "POST",
    credentials: "include",
    body: form,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`CSV-Vorschau fehlgeschlagen (${res.status}): ${text}`);
  }
  return (await res.json()) as ContactImportPreview;
}

export interface ContactImportCommitResult {
  inserted: number;
  skipped: number;
  /** Anzahl übersprungener Zeilen, weil der Kontakt bereits existiert. */
  duplicates: number;
  duplicateRows?: ContactImportDuplicate[];
  errors?: string[];
}

export function commitContactImport(payload: {
  mapping: Record<string, string>;
  headers: string[];
  rows: string[][];
  defaultContactType?: string;
}): Promise<ContactImportCommitResult> {
  return postRequestGeneric("/protected/contacts/import/commit", payload, true);
}
